import { Box, Checkbox, FormControlLabel } from "@mui/material"
import { useTranslation } from "react-i18next";

export const CheckboxInput = ({value, isDisabled = false, title, handleInputChange, required = false, small = false, translation}) => {

  const { t } = useTranslation('global');

  return (
    <Box minWidth={small ? 'calc(33% - 5px)' : 'calc(50% - 8px)'}>
      <FormControlLabel 
        required={required}
        disabled={isDisabled}
        sx={{ color: 'secondary.main' }}
        control={<Checkbox checked={value} onChange={(evt) => 
          handleInputChange({ 
            ...evt, 
            target: { 
              ...evt.target, 
              value: evt.target.checked,
              name: title 
            } 
          })
        } />}
        label={t(`${translation}.${title}`)}
      />
    </Box>
  )
}
